const footerLinks = [
  { label: '甜番精选', href: '#recommend' },
  { label: '心动榜单', href: '#ranking' },
  { label: '挑选标准', href: '#standards' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

const categoryLinks = [
  { label: '高甜狗粮番', href: '#recommend' },
  { label: '纯爱治愈番', href: '#recommend' },
  { label: '暧昧拉扯番', href: '#recommend' },
  { label: '心动初绽番', href: '#recommend' },
];

export default function Footer() {
  return (
    <footer className="bg-background-200/80 border-t border-background-300/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl md:text-2xl text-foreground-900">羞羞的动漫</span>
            </a>
            <p className="mt-4 max-w-md text-sm text-foreground-600 leading-relaxed">
              一个只聊心动、不谈套路的恋爱甜番推荐站。高甜、纯爱、狗粮与暧昧心动全都有，甜度测评 + 心动名场面，陪你挑一部开刷。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600 transition-colors">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600 transition-colors">
                <i className="ri-bilibili-line text-lg"></i>
              </span>
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600 transition-colors">
                <i className="ri-douban-line text-lg"></i>
              </span>
              <a
                href="#subscribe"
                className="ml-2 inline-flex items-center gap-1.5 px-4 py-2 text-sm text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md whitespace-nowrap transition-colors"
              >
                <i className="ri-mail-send-line"></i>
                订阅更新
              </a>
            </div>
          </div>

          <nav aria-label="快速导航">
            <h3 className="font-heading text-base text-foreground-950">快速导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {footerLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-base text-foreground-950">心动分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categoryLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 羞羞的动漫 · 恋爱甜番推荐合集，持续更新中</p>
          <p className="text-xs text-foreground-500 inline-flex items-center gap-1.5">
            <i className="ri-mail-line"></i>
            hello@xiuxiudongman.com
          </p>
        </div>
      </div>
    </footer>
  );
}